import React, { useEffect, useState } from "react";
import api from "APP_ROOT/api";
import T from "prop-types";
import { daysAgo } from "LIB/time";
import { Warning } from "MODULES/shared/components";
import { get } from "lodash";
import { shortDate } from "LIB/formatters/date";
import { ID } from "APP_ROOT/constants";

function ExistingQuoteWarning({ part, company, sellerId }) {
  if (!get(company, ID) || !part) return null;

  const [quotes, setQuotes] = useState([]);

  useEffect(
    () => {
      api.parts.outgoingQuoteLineItems
        .search(part.id, {
          company_id: company.id,
          created_after: daysAgo(30)
        })
        .then(resp => {
          setQuotes(
            resp.data.results.filter(
              q => Number(sellerId) !== Number(q.created_by_id)
            )
          );
        });

      return function cleanup() {};
    },
    [part.id, company.id, sellerId]
  );

  if (quotes.length === 0) return null;
  const quote = quotes[0];

  return (
    <tr>
      <td>
        <Warning>
          This part number has already been quoted to {company.name} in the last
          30 days. It was last quoted by {get(quote, "created_by.full_name")} to{" "}
          {company.name} on {shortDate(quote.created_at)}.
        </Warning>
      </td>
    </tr>
  );
}

ExistingQuoteWarning.propTypes = {
  company: T.shape({}),
  part: T.shape({}),
  sellerId: T.string
};

export default ExistingQuoteWarning;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/ConvertFromCartForm/ExistingQuoteWarning.jsx